module.exports = __webpack_public_path__ + "img/581.9faf9137.jpg";